import React from 'react'

export default function NoCamerasPresent() {
    return <div className="no-camera-found">
        <p className='noRecordFoundText'>No Record Available</p>
    </div>
}
